/**
 * Copyright 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Modal } from "@nordcloud/gnui";
import { useDisclosure } from "~/hooks";
import { SERVICENOW_MSG_PREVIEW_MODAL_TITLE } from "../../constants";
import { SavingSuggestionsPreviewMessage } from "../../PreviewMessages";
import { SavingSuggestionsOptionsDataTypeField } from "./SavingSuggestionsOptionsDataTypeField";
import { ShortDescriptionField } from "./ShortDescriptionField";

type Props = {
  isReadMode: boolean;
};

export function SavingSuggestionsOptionsSection({ isReadMode }: Props) {
  const { isOpen, close, open } = useDisclosure();

  return (
    <>
      <ShortDescriptionField isReadMode={isReadMode} />
      <SavingSuggestionsOptionsDataTypeField
        isReadMode={isReadMode}
        onPreviewClick={open}
      />
      <Modal
        isOpen={isOpen}
        actions={[]}
        contentMaxHeight="40rem"
        contentLabel={SERVICENOW_MSG_PREVIEW_MODAL_TITLE}
        onClose={close}
      >
        <SavingSuggestionsPreviewMessage />
      </Modal>
    </>
  );
}
